import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import useTranslation from "next-translate/useTranslation";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  contentTitle: {
    textAlign: "center",
    fontSize: "20px",
    marginTop: "40px",
  },

  contentSubTitle: {
    fontFamily: theme.highlightFontFamily,
    textAlign: "center",
    fontSize: "36px",
    fontWeight: "bold",
    lineHeight: "37px",
    marginTop: 0,
  },

  descriptionContent: {
    marginTop: "30px",
    fontSize: "20px",
    textAlign: "center",
    fontWeight: 300,
    "@media (max-width: 768px)": {
      width: "90%",
    },
    "@media (max-width: 425px)": {
      width: "100%",
    },
  },

  contentContainer: {
    maxWidth: "500px",
    margin: "auto",
  },
}));

const TopContent = ({ brandName }) => {
  const { t } = useTranslation("marken");
  const classes = useStyles();
  return (
    <div className={classes.contentContainer}>
      <div className={classes.contentTitle}>{t("brandsTitle")}</div>
      <h1 className={classes.contentSubTitle}>{t("productDetailsHeadline", { brandName })}</h1>
      <h2 className={classes.descriptionContent}>{t("productDetailsIntro", { brandName })}</h2>
    </div>
  );
};

export default TopContent;
